/** 見学予約・資料請求リストの追尾表示制御 */
export const stickyOrderListView = (): void => {

  $(window).on('scroll', () => {
    const $resultBox = $('.resultBox');
    const $resultBlock = $('.resultBlock');
    const $requestListBox = $('.requestListBox');
    const $requestListArea = $('.requestListArea .requestListBox');

    // 検索結果 0件時
    if ($resultBlock.length === 0) {
      $requestListArea.css({ position: 'relative', top: '0px' });
      return;
    }

    // 現在の表示位置
    const currentHeight = $(window).scrollTop() || 0;

    // 検索結果一覧の表示位置
    const resultBoxHeight = $resultBox.offset()?.top || 0;

    // 見学予約・資料請求リストの最下段表示位置
    const bottomHeight = ($resultBlock.last().offset()?.top || 0) + ($resultBlock.last().height() || 0) + 10 - ($requestListBox.height() || 0) - ($('.requestListArea').offset()?.top || 0);

    // 現在の表示位置が検索結果一覧よりも上の場合
    if (!(currentHeight > resultBoxHeight - 20)) {
      $requestListArea.removeClass('fixed');
      return;
    }

    // 現在の表示位置が最下段表示位置より下の場合
    if (currentHeight > bottomHeight) {
      $requestListArea.removeClass('fixed');
      $requestListArea.css({ position: 'absolute', top: `${bottomHeight}px` });
      return;
    }

    // 現在の表示位置が検索結果一覧～最下段表示位置の間の場合
    $requestListArea.addClass('fixed');
    $requestListArea.css({ position: '', top: '' });
  });
};
